import { render, staticRenderFns } from "./ChallengesComponent.vue?vue&type=template&id=256cb47a&scoped=true&"
import script from "./ChallengesComponent.vue?vue&type=script&lang=ts&"
export * from "./ChallengesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengesComponent.vue?vue&type=style&index=0&id=256cb47a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cb47a",
  null
  
)

export default component.exports